import Slider from 'react-slick';

import Arrow from '../../../assets/about/about-arrow.svg';
import ScrollInAnimationItem from '../../../components/scrollInAnimationItem/ScrollInAnimationItem';
import { ScrollAnimationType } from '../../../enums/scroll-animation-type.enum';
import { ABOUT_PARTNERS } from '../constants/about-partners.constants';

import styles from './AboutPartnersSection.module.scss';

const AboutPartnersSection = () => {
  const itemsPerSlide = 4;
  const partnersSmall = Array(Math.ceil(ABOUT_PARTNERS.length / itemsPerSlide))
    .fill(() => null)
    .map((value, index) => [
      ABOUT_PARTNERS[index * itemsPerSlide],
      ABOUT_PARTNERS[index * itemsPerSlide + 1],
      ABOUT_PARTNERS[index * itemsPerSlide + 2],
      ABOUT_PARTNERS[index * itemsPerSlide + 3],
    ]);

  return (
    <div className={styles['section']}>
      <div className={styles['content']}>
        <ScrollInAnimationItem animationType={ScrollAnimationType.slideInTop} delay="0.1s" threshold={0.3}>
          <h2>Partners</h2>
        </ScrollInAnimationItem>
        <ScrollInAnimationItem
          className={styles['arrow']}
          delay="0.4s"
          threshold={0.3}
          animationType={ScrollAnimationType.slideInLeft}
        >
          <img alt="" src={Arrow} />
        </ScrollInAnimationItem>

        <div className={`${styles['partners-wrapper']} ${styles['partners-list']}`}>
          {ABOUT_PARTNERS.map(({ ImageComponent, label, link }, index) => (
            <ScrollInAnimationItem
              key={label}
              className={styles['partners-item-container']}
              delay={`${0.2 + index * 0.1}s`}
              threshold={0.3}
            >
              <a aria-label={label} className={styles['partners-item']} href={link} rel="noreferrer" target="_blank">
                <ImageComponent />
                <ImageComponent className={styles['before']} />
                <ImageComponent className={styles['after']} />
              </a>
            </ScrollInAnimationItem>
          ))}
        </div>

        <Slider
          autoplay
          dots
          infinite
          arrows={false}
          lazyLoad="ondemand"
          dotsClass={`slick-dots ${styles['partners-slider__dots']}`}
          className={styles['partners-slider']}
          speed={1000}
          slidesToScroll={1}
          slidesToShow={1}
        >
          {partnersSmall.map((partnersGroup) => (
            <div key={`group-parent-${partnersGroup[0].label}`}>
              {partnersGroup.map(({ ImageComponent, label, link }, index) => (
                <a
                  key={`group-link-${label}`}
                  aria-label={label}
                  className={styles['partners-item']}
                  href={link}
                  rel="noreferrer"
                  target="_blank"
                >
                  <ImageComponent />
                </a>
              ))}
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default AboutPartnersSection;
